import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "city"
const CityIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12.823 7.688C13.631 7.688 14.417 7.963 15.048 8.468L17.865 10.721 21.235 11.335C21.86 11.449 22.313 11.992 22.313 12.626V15.375C22.313 16.1 21.725 16.688 21 16.688H19.898C19.444 17.472 18.596 18 17.625 18S15.806 17.472 15.352 16.688H8.272C7.82 17.472 6.973 18 6 18S4.181 17.472 3.727 16.688H3C2.275 16.688 1.688 16.1 1.688 15.375V13.727C1.688 12.762 2.138 11.857 2.898 11.275L2.966 11.072 3.72 8.812H3.375C3.065 8.813 2.813 8.562 2.813 8.25 2.813 7.94 3.064 7.688 3.375 7.688zM6 14.25C5.379 14.25 4.875 14.754 4.875 15.375S5.379 16.5 6 16.5 7.125 15.996 7.125 15.375 6.621 14.25 6 14.25M17.625 14.25C17.004 14.25 16.5 14.754 16.5 15.375S17.004 16.5 17.625 16.5 18.75 15.996 18.75 15.375 18.246 14.25 17.625 14.25M4.28 10.688H4.875C5.185 10.688 5.438 10.939 5.438 11.25 5.438 11.56 5.186 11.813 4.875 11.813H3.906L3.847 11.986 3.687 12.093C3.141 12.457 2.813 13.07 2.813 13.727V15.375C2.813 15.479 2.896 15.563 3 15.563H3.383Q3.376 15.47 3.375 15.375C3.375 13.925 4.55 12.75 6 12.75S8.625 13.925 8.625 15.375Q8.624 15.47 8.617 15.563H15.008Q15.001 15.47 15 15.375C15 13.925 16.175 12.75 17.625 12.75S20.25 13.925 20.25 15.375Q20.249 15.47 20.242 15.563H21C21.104 15.563 21.188 15.479 21.188 15.375V13.688H20.625C20.315 13.688 20.063 13.436 20.063 13.125S20.314 12.563 20.625 12.563H21.177C21.154 12.5 21.1 12.453 21.034 12.442L17.573 11.812H10.674C9.658 11.813 8.75 11.183 8.392 10.233L7.86 8.811H4.906zM9.445 9.836C9.637 10.348 10.127 10.687 10.675 10.687H16.02L14.345 9.348C13.913 9 13.375 8.812 12.822 8.812H9.063z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default CityIcon
